<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>View a Module</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">
  <h6>Module Name</h6>
  <p>{{ module.name }}</p>

  <h6>Module Introduction</h6>
  <div [innerHTML]="module.description | sanitizeHtml"></div>
</mat-dialog-content>

